export default __webpack_public_path__ + "static/roel_van_de_ven-e181ec4b30e34683314c79e5ba0d2cf8.jpg";